<div class="main-div" aria-hidden="true"></div>
<div class="overlay" *ngIf="loading"
     role="status" aria-live="polite" aria-busy="true">
    <div class="center">
        <mat-spinner class="custom-spinner"
                     aria-hidden="true">
        </mat-spinner>
    </div>
</div>

<main class="login-wrapper" id="login-main"
      [attr.inert]="loading ? '' : null">
    <mat-card class="login-card">
        <mat-card-content>
            <header class="login-card-header">
                <h1 class="login-title">Sign in to Cypher Court</h1>
                <p class="login-subtitle">
                    Enter your credentials to access the clerk portal
                </p>
            </header>

            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <div class="field-wrap">
                    <mat-form-field class="full-width" appearance="outline">
                        <mat-label>User Name</mat-label>
                        <input matInput
                               type="text"
                               name="username"
                               id="username"
                               formControlName="username"
                               required
                               autocomplete="username"
                               [attr.aria-invalid]="usernameInvalid()"
                               [attr.aria-describedby]="usernameDescribedBy()">
                        <mat-error id="username-error-required"
                                   *ngIf="username?.hasError('required')">
                            Username is required
                        </mat-error>
                        <mat-error id="username-error-invalid"
                                   *ngIf="username?.hasError('invalidUsername')">
                            Invalid username
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="field-wrap">
                    <mat-form-field class="full-width" appearance="outline">
                        <mat-label>Password</mat-label>
                        <input matInput
                               id="password"
                               [type]="hidePassword ? 'password' : 'text'"
                               formControlName="password"
                               autocomplete="current-password"
                               [attr.aria-invalid]="passwordInvalid()"
                               [attr.aria-describedby]="passwordDescribedBy()">
                        <button mat-icon-button
                                matSuffix
                                (click)="hidePassword = !hidePassword"
                                type="button"
                                [attr.aria-label]="passwordToggleLabel()"
                                [attr.aria-pressed]="!hidePassword">
                            <mat-icon aria-hidden="true">
                                {{ hidePassword ? 'visibility_off' : 'visibility' }}
                            </mat-icon>
                        </button>
                        <mat-error id="password-error-required"
                                   *ngIf="password?.hasError('required')
                                       && password?.touched">
                            Password is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <mat-card-actions class="login-actions">
                    <button mat-raised-button
                            type="submit"
                            color="primary"
                            class="full-width login-primary-button">
                        Sign in
                    </button>
                </mat-card-actions>

                <div class="sso-section" *ngIf="showMicrosoftLogin">
                    <p class="sso-divider" role="presentation">
                        <span>or</span>
                    </p>
                    <button mat-stroked-button
                            type="button"
                            class="full-width microsoft-button"
                            (click)="onSsoLogin()">
                        <span class="microsoft-content">
                            <span class="microsoft-logo" aria-hidden="true">
                                <span class="tile red"></span>
                                <span class="tile green"></span>
                                <span class="tile blue"></span>
                                <span class="tile yellow"></span>
                            </span>
                            <span class="microsoft-text">
                                Sign in with Microsoft
                            </span>
                        </span>
                    </button>
                </div>
            </form>

            <div *ngIf="error"
                 id="login-form-error"
                 role="alert"
                 [ngClass]="isSessionMessage
                     ? 'session-message'
                     : 'error-message'">
                {{ error }}
            </div>
        </mat-card-content>
    </mat-card>
</main>
